// extracted by mini-css-extract-plugin
export default {"animateFloat":"Loading_animateFloat__RaKrm","float":"Loading_float__GD6qR","spin":"Loading_spin__MKqm5"};